import { render, staticRenderFns } from "./LomovotiveAdmin.vue?vue&type=template&id=050dfa70&"
import script from "./LomovotiveAdmin.vue?vue&type=script&lang=js&"
export * from "./LomovotiveAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports